import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CheckBoxSlider from '../../../../Shared/CheckBoxSlider/CheckBoxSlider';
import PopUp from '../../../../Shared/Popup/PopUp';
import { updateWifiSettingsAsync } from '../../WifiManagementBlockAsyncThunk';
import { reportDWH } from '../../WifiManagementBlockSlice';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { validateField } from '../../../../../utilities/validation/formValidation';
import successIcon from './images/success-icon.svg';
import errorIcon from './images/error-icon.svg';

const NetworkItem = (props) => {
    const [formData, setFormData] = useState({
        name: {
            value: props.item.networkName,
            error: '',
            validationRules: {
                required: true,
                requiredMessage: 'אנא הזן שם רשת',
                regexName: 'nameAndPasswordRegex',
                regexMessage: 'שם רשת לא תקין - אנגלית, מספרים ותווים מיוחדים בלבד',
                maxLength: 32,
                minLength: 1,
                maxLengthMessage: 'שם רשת יכול להכיל עד 32 תווים'
            }
        },
        password: {
            value: '',
            error: '',
            validationRules: {
                required: true,
                requiredMessage: 'אנא הזן סיסמא',
                regexName: 'nameAndPasswordRegex',
                regexMessage: 'סיסמא לא תקינה - אנגלית, מספרים ותווים מיוחדים בלבד',
                maxLength: 63,
                minLength: 8,
                maxLengthMessage: 'סיסמא יכולה להכיל עד 63 תווים'
            }
        }
    });

    const [isShowLoader, setIsShowLoader] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState(false);

    const [isDisplayNetworkDetailsPopup, setIsDisplayNetworkDetailsPopup] = useState(false);
    const [networkDetailsStatus, setNetworkDetailsStatus] = useState('');

    // const [isDisplaySuccessPopup, setIsDisplaySuccessPopup] = useState(false);
    // const [isDisplayErrorPopup, setIsDisplayErrorPopup] = useState(false);
    useEffect(() => {
        props.reportDWH({ actionType: 'Wifi Configuration Page', status: 'Ongoing', messageText: 'Wifi Configuration Page Displayed', param1:props.item.networkExists?'': 'No Details Exists' });
    }, []);

    return (
        <div className='network-item-wrapper'>
            {
                props.isDisplayNetworkTypes &&
                <div className='network-type'> {getNetworkType(props.item.frequencyBand)} </div>
            }

            <div className='network-item-details'>

                <div className='network-item'>

                    {
                        props.item.networkExists ? (
                            <>
                                <div className='row-wrapper'>
                                    <div className='details-wrapper'>
                                        <div className='details'>
                                            <div className='details-field'> שם הרשת: </div>
                                            <div className='details-value'> {props.item.networkName} </div>
                                        </div>
                                        {/* <div className='links-wrapper'>
                                            <a href='#' className='edit-icon' onClick={(e) => handleOnEditName(e)}></a>
                                        </div> */}
                                    </div>
                                </div>

                                <div className='row-wrapper'>
                                    <div className='details-wrapper'>
                                        <div className='details'>
                                            <div className='details-field'> סיסמה: </div>
                                            <div className='details-value'> { getNetworkPassword(props.item.networkPass) } </div>
                                        </div>
                                        <div className='links-wrapper'>
                                            {/* <a href='#' className='edit-icon' onClick={(e) => handleOnEditPassword(e)}></a> */}
                                            <a href='#' className={isShowPassword ? 'password-show' : 'password-hide'} onClick={(e) => handleDisplayPasswordClick(e)}></a>
                                        </div>
                                    </div>
                                    {
                                        !props.item.networkPass &&
                                        <div className='remark-wrapper'>
                                            <span> ללא סיסמה הרשת שלך עלולה להיות לא מוגנת </span>
                                        </div>
                                    }
                                </div>

                                <div className='row-wrapper'>
                                    <div className='details-wrapper'>
                                        <div className='details'>
                                            <div className='details-field'> מצב הרשת: </div>
                                        </div>
                                        <div className='checkbox-wrapper'>
                                            <CheckBoxSlider
                                                checked={props.item.networkEnable}
                                                id={`network-status-${props.item.networkType}`}
                                                onChange={(e) => handleOnStatusChange(e)}
                                                isShowLoader={isShowLoader}
                                                textChecked='פעיל'
                                                textNotChecked='כבוי'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row-wrapper'>
                                    <div className='update-link-wrapper'>
                                        <a href='#'  onClick={(e) => handleOnEditName(e)}>
                                            עדכון שם רשת וסיסמה
                                        </a>
                                    </div>
                                </div>
                            </>) : (
                                    <div className='row-wrapper network-setup-message'>
                                        <div className='details-field'>
                                            {props.WifiNotInstalledText || 'כדי להמשיך, יש להגדיר מחדש את פרטי הרשת. ניתן לעשות זאת כעת.'}
                                        </div>
                                        <div className='popup-btn-wrapper'>
                                            <BtnSubmit text='הגדרת שם רשת או סיסמה' onclick={handleOnAddNetwork} />
                                        </div>
                                    </div>
                                  )
                    }


                </div>

            </div>

            <PopUp showPopUp={isDisplayNetworkDetailsPopup} onClose={() => {
                setNetworkDetailsStatus('');
                setIsDisplayNetworkDetailsPopup(false);
                }}>
                {renderNetworkDetailsPopup()}
            </PopUp>

        </div>
    );

    function renderNetworkDetailsPopup() {
        switch (networkDetailsStatus) {
            case '':
                return(
                    <form noValidate id='form-network-details' onSubmit={(e)=> e.preventDefault()}>
                        <div>
                            <div className='popup-title'> עדכון שם וסיסמת רשת ה-Wi-Fi </div>
                            <div className='popup-sub-title'>לאחר העדכון כל המכשירים שמחוברים<br></br> לרשת Wi-Fi יתנתקו ויהיה צורך לחבר אותם עם הפרטים החדשים</div>
                            <div className='popup-field'>
                                <TextInput placeholder='שם הרשת' error={formData.name.error} onChange={(e) => { validate('name', e.target.value) }} value={formData.name.value} autocomplete='off' maxlength='32' required />
                            </div>
                            <div className='popup-field'>
                                <TextInput placeholder='סיסמא' error={formData.password.error} onChange={(e) => { validate('password', e.target.value) }} value={formData.password.value} autocomplete='off' maxlength='63' required />
                            </div>
                            <div className='popup-btn-wrapper'>
                                <BtnSubmit text='שמירה' onclick={handleSaveNetworkDetails} formid='form-network-details' />
                            </div>
                        </div>
                    </form>
                )
            case 'success':
                return(
                    <div>
                        <div className='popup-success-icon' style={{backgroundImage:successIcon.bg()}}></div>
                        <div className='popup-title'> העדכון נשמר בהצלחה </div>
                        <div className='popup-btn-wrapper'>
                            <BtnSubmit text='סיום' onclick={()=> setIsDisplayNetworkDetailsPopup(false)} />
                        </div>
                    </div>
                )
            case 'error':
                return(
                    <div>
                        <div className='popup-error-icon' style={{backgroundImage:errorIcon.bg()}}></div>
                        <div className='popup-title'> משהו השתבש <br></br>והפרטים לא עודכנו </div>
                        <div className='popup-btn-wrapper'>
                            <BtnSubmit text='הבנתי, תודה' onclick={()=> setIsDisplayNetworkDetailsPopup(false)} />
                        </div>
                    </div>
                )
        }
    }

    function getNetworkPassword(networkPass) {
        if (!networkPass) { return 'לא מוגדרת'; }
        return (isShowPassword ? networkPass : '********');
    }

    function getNetworkType(frequency) {
        switch (frequency) {
            case '2.4GHz': return '2.4 GHz Network';
            case '5GHz': return '5 GHz Network';
            case '6GHz': return 'wifi6 Network';
            default: return '';
        }
    }

    function handleDisplayPasswordClick(e) {
        e.preventDefault();
        setIsShowPassword(!isShowPassword);
    }

    function handleOnEditName(e) {
        e.preventDefault();
        setFormData(prev => ({
            ...prev,
            name: { ...prev.name, value: props.item.networkName},
            password: { ...prev.password, value: '', error: '' }
        }));
        setIsShowPassword(false);
        setNetworkDetailsStatus('');
        setIsDisplayNetworkDetailsPopup(true);
    }

    async function handleSaveNetworkDetails() {
        let errorName = validate('name', formData.name.value);
        let errorPassword = validate('password', formData.password.value);
        if (errorName || errorPassword) { return; }

        // error = checkNetworkName();
        // if (error) { return; }

        const updatedItem = { ...props.item, networkName: formData.name.value, networkPass: formData.password.value, networkEnable: (!props.item.networkExists ? true : props.item.networkEnable) }
        const res = await props.updateWifiSettingsAsync({ isDisplayLoader: true, networkList:[updatedItem] });

        const isSuccess = res?.payload?.checkConnection?.isSuccess;
        if (isSuccess) {
            props.reportDWH({ actionType: 'Wifi Details Update', status: 'Completed', messageText: 'Wifi Details Update Success',param1:props.item.networkExists?'': 'New Details Added' });
            setNetworkDetailsStatus('success');
        }
        else {
            props.reportDWH({ actionType: 'Wifi Details Update', status: 'Error', messageText: 'Wifi Details Update Error',param1:props.item.networkExists?'': 'New Details Added' });
            setNetworkDetailsStatus('error');
        }
    }

    async function handleOnStatusChange(e) {
        setIsShowLoader(true);
        const networkEnable = e.target.checked;
        const updatedItem = { ...props.item, networkEnable: networkEnable }
        const res = await props.updateWifiSettingsAsync({ isDisplayLoader: false, networkList:[updatedItem] });
        if(networkEnable) {
            props.reportDWH({ actionType: 'Toggle Selection', status: 'Completed', messageText: 'Toggle Selection Success' });
        } else {
            props.reportDWH({ actionType: 'Toggle UnSelection', status: 'Completed', messageText: 'Toggle UnSelection Success' });
        }
        setIsShowLoader(false);
    }

    function handleOnAddNetwork() {
        setFormData(prev => ({
            ...prev,
            name: { ...prev.name, value: '', error: '' },
            password: { ...prev.password, value: '', error: '' }
        }));
        setIsShowPassword(false);
        setNetworkDetailsStatus('');
        setIsDisplayNetworkDetailsPopup(true);
    }

    function validate(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
        return error;
    }

    function checkNetworkName() {
        let data = formData;
        let error = '';

        const network = props.networkWiFis.find(x=> x.networkName == data['name'].value);
        // if (network) {
        //     error = 'שם רשת כבר קיים, יש לבחור שם רשת שונה';
        //     data['name'].error = error;
        //     setFormData({ ...data });
        // }
        return error;
    }

};

const mapStateToProps = (state) => {
    return {
        networkWiFis: state.wifiManagementBlock?.networkWiFis,
        WifiNotInstalledText: state.wifiManagementBlock?.wifiNotInstalledText
    };
};

const mapDispatchToProps = {
    updateWifiSettingsAsync,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(NetworkItem);
